import { combineReducers } from 'redux';

import isSignUpCheckIsFetching from './isSignUpCheckIsFetching';
import signUpEmail from './signUpEmail';

export default combineReducers({
  isSignUpCheckIsFetching,
  signUpEmail,
});
